import React, { useMemo } from 'react';
import style from "./Carta.module.css";

const CategoriesNav = ({ 
  categorias,
  categoriasSinProductos,
  categoriaID,
  getID,
  onCategoriaClick,
  itemsRef,
  onMouseDown,
  onMouseLeave,
  onMouseUp,
  onMouseMove
}) => {
  const categoriasFiltradas = useMemo(() => {
    return categorias.filter(categoria => !categoriasSinProductos.has(getID(categoria)));
  }, [categorias, categoriasSinProductos, getID]);

  return (
    <div
      className={style.chooseBrand}
      ref={itemsRef}
      onMouseDown={onMouseDown}
      onMouseLeave={onMouseLeave}
      onMouseUp={onMouseUp}
      onMouseMove={onMouseMove}
    >
      {categoriasFiltradas.map((categoria) => (
        <div key={getID(categoria)} style={{ padding: '0 5px', minWidth: 'fit-content' }}>
          <button 
            className={`${style.categoria_btn} ${categoriaID === getID(categoria) ? style.categoria_btn_active : ''}`} 
            onClick={() => onCategoriaClick(categoria)}
          >
            {categoria.nombre}
          </button>
        </div>
      ))}
    </div>
  );
};

export default CategoriesNav;